module.exports = __webpack_public_path__ + "img/index-banner1.27d36925.png";